import { keepPreviousData } from "@tanstack/react-query";

import { getClosingCartons } from "@/api/production-api";
import type { ClosingCartonsResponse } from "@/schemas";
import { useCancellingQuery } from "@/hooks/use-cancelling-query";

const REFETCH_INTERVAL = 15 * 1000;

export interface UseClosingFailedJobsProps {
	filter: string | null;
	pageNumber: number;
	pageSize: number;
}

export const CLOSING_FAILED_JOBS_QUERY_KEY = "closing-failed-cartons";

export const useClosingFailedJobs = ({ filter, pageNumber, pageSize }: UseClosingFailedJobsProps) => {
	const queryKey = [CLOSING_FAILED_JOBS_QUERY_KEY, pageNumber, pageSize, filter];

	const queryFn = () =>
		getClosingCartons({
			identifier: filter,
			pageNumber,
			pageSize,
			closingType: "Failed",
		});

	const { data, isLoading, error, refetch } = useCancellingQuery<ClosingCartonsResponse>({
		queryKey,
		queryFn,
		placeholderData: keepPreviousData,
		refetchInterval: REFETCH_INTERVAL,
	});

	return {
		data,
		isLoading,
		error,
		refetch,
	};
};
